module.exports = __webpack_public_path__ + "Flag-598.593779184c5703102697703c6a52b5c2.svg";